import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';
// import { HomeComponent } from './modules/home/pages/home.component';
import { LoginComponent } from './components/login/login.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NewsComponent } from './modules/public/pages/news/news.component';
import { NewsCategoryComponent } from './modules/public/pages/news/news-category/news-category.component';
import { NewsDescComponent } from './modules/public/pages/news/news-desc/news-desc.component';
import { environment } from 'src/environments/environment';
import { NewsSearchComponent} from'./modules/public/pages/news/news-search/news-search.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { PodcastHomeComponent } from './podcast/podcast-home/podcast-home.component';
import { PodcastComponent } from './podcast/podcast.component';
import { PodcastDetailComponent } from './podcast/podcast-detail/podcast-detail.component';
import { EpisodeDetailComponent } from './podcast/episode-detail/episode-detail.component';
import { AllPodcastListComponent } from './podcast/all-podcast-list/all-podcast-list.component';
import { PodcastNewsComponent } from './podcast/podcast-news/podcast-news.component';


const routes: Routes = [

  
  { path: 'admin', component: LoginComponent },
  {
    path: 'admin', component: AdminLayoutComponent,
    children: [{
      path: '',
      loadChildren: () => import('./modules/admin/admin.module').then(x => x.AdminModule)
    }]
  },
  {
    path: 'podcasts-web', component: PodcastComponent,
    children
    : [{
      path: '', component: PodcastHomeComponent,
    },
    {
      path: 'podcast/:podcastname', component: PodcastDetailComponent,
    },
    {
      path: 'category/:cat', component: AllPodcastListComponent,
    },
    {
      path: 'episode/:episodename', component: EpisodeDetailComponent,
    },
    {
      path: 'news', component: PodcastNewsComponent,
    }
  ]
  },
  // {
  //   path: '',
  //   component: ContentLayoutComponent,
  //   children: [{
  //     path: '',
  //     loadChildren: () => import('./modules/public/public.module').then(x => x.PublicModule)
  //   }],
  // },

  {
    path: '',
    component: ContentLayoutComponent,
    children: CONTENT_ROUTES,
  },
  // {
//     path: 'news',
//     component: NewsComponent,
//     // data: { title: 'Hayti News' },
// //     data:{ title:'newspage|dynamic title and meta tags',
// //   metaTags:[
// // {name:'description',content:'news pages'},
// // {property:'og:title',content: 'Game of Thrones Quotes'},
// // { property: 'og:image', content: environment.appUrl + 'assets/image/homepage.png' },
// // { property: 'og:url', content: environment.appUrl + 'home' },
// // ]}
   
//   children: [
//     {
//       path: ':category',
//       // matcher: categoryCustomerMatcher,
//       component: NewsCategoryComponent,
    
//       // data:{
//       //   title: 'Title for Home Component',
//       //   descrption: 'Description of Home Component',
//       //   ogTitle: 'Description of Home Component for social media',
//       // },


//       // children: [
//       // {
//       //   path: ':desc',
//       //   component: NewsDescComponent,
//       // }
//       // ]
//     },
//     {
//       path: ':cat/:desc',
//       component: NewsDescComponent,
//     },
//     // {
//     //   path:'search/search/search',
//     //   component:NewsSearchComponent,
//     //   data:{type:'search'}
//     // }

//   ]
//     // children: CONTENT_ROUTES,
//   },
// {
//   path: 'news/:category',
//   component: NewsCategoryComponent,
//   // children: CONTENT_ROUTES,
// },


// fallback when no prior routes in matched
// {
//   path: '**', redirectTo: '', pathMatch: 'full'
// },
{
  path: '',
    redirectTo: '/', // redirect to `main page`
      pathMatch: 'full'
},
{ path: '404', component: NotfoundComponent },
{ path: '**', redirectTo: '404' }

];


@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabled', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

// export function categoryCustomerMatcher(url: UrlSegment[]){
  // console.log("url", url.length)
  // return url;
  // return url.length === 1  ? ({consumed: url}) : null;
//  }
